// extracted by mini-css-extract-plugin
export default {"titlePage":"CaptivePortal_titlePage__64xON","iconInfo":"CaptivePortal_iconInfo__rNoiN"};